// setting noZensmooth to true, to disable zenscroll
// from listening to global events and execute handlers,
// as it is affecting backbone apps navigation
// related defects: DE546728, DE546878
window.noZensmooth = true;